module.exports = __webpack_public_path__ + "img/home_zh_CN_img1.72471743.png";